import { Navigate, Route, Routes } from "react-router-dom";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import useChangeOrderAccess from "./hooks/useChangeOrderAccess";
import RolesHint from "./RolesHint/RolesHint";
import List from "./List/List";
import New from "./New/New";
import Edit from "./Edit/Edit";

interface Props {
  // A number when mounted from the Rails view (react-nav off).
  project_id: string | number;
}

const ChangeOrdersMspa = ({ project_id }: Props) => {
  const access = useChangeOrderAccess();
  // Children compare ids as strings and share query cache keys with SowHeader.
  const projectId = String(project_id);

  if (access.loading) return <ScopeStackSpinner />;
  if (access.showRolesHint) return <RolesHint />;
  if (!access.canView) {
    return <div className="p-3">You do not have access to change requests.</div>;
  }

  return (
    <Routes>
      <Route index element={<List projectId={projectId} />} />
      <Route path="new" element={<New projectId={projectId} />} />
      <Route
        path=":changeOrderId/edit"
        element={<Edit projectId={projectId} />}
      />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default ChangeOrdersMspa;
